import React, {memo} from 'react';
import FileManagerDialog, {FileManagerDialogProps} from './FileManagerDialog';

export type FileManagerDialogData = Omit<FileManagerDialogProps, 'onClose' | 'onConfirm'>;
type Props = {
   data: FileManagerDialogData;
   onClose: (path?: string) => void;
};
const FileManagerDialogWrapper = memo(({data, onClose}: Props) => {
   return <FileManagerDialog {...data} open={true} onClose={onClose} onConfirm={onClose} />;
});

export default FileManagerDialogWrapper;
